import React, { Component, Fragment } from "react";
import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import {
	Card,
	Spin,
	Row,
	Col,
	Button,
	Form,	
	Icon,
	message,	
	Input,
	Tabs	
} from "antd";
import { locationPrefix } from "common/general";
import { inject, observer } from "mobx-react";
import LinksTab from "./components/LinksTab";
import KeywordsTab from "./components/KeywordsTab";

const TabPane = Tabs.TabPane;


@inject("rootStore")
@observer
class LinksPage extends Component {
	render() {
		const {
			rootStore: { linksStore }
		} = this.props;

		const ui = linksStore.ui;

		let breadcrumbList = "";
		
		if (!ui.loadingLinks) {
			breadcrumbList = [
				{
					title: "Home",
					href: locationPrefix + "/"
				},
				{
					title: "Campaigns",
					href: locationPrefix + "/"
				},
				{
					title: "Campaign",
					href: locationPrefix + "/campaign/" + linksStore.campaign.id
				},
				{
					title: "Links"
				}
			];			
		}

		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
				sm: { span: 24 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 24 }
			}
		};

		return (
			<Fragment>
				{ui.loadingLinks == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title={"Link set: " + linksStore.urlList.name}
					>						
						<Card>
							<Tabs>
								<TabPane tab="Links" key="LinksTab" forceRender={true}>
									<LinksTab />
								</TabPane>
								<TabPane tab="Keywords" key="KeywordsTab" forceRender={true}>
									<KeywordsTab />									
								</TabPane>
							</Tabs>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}

export default LinksPage;
